import React from "react";
import Types from "prop-types";
import GoogleAnalytics from "react-ga";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Analytika from "../analytika";

GoogleAnalytics.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);

export const trackPage = (page) => {
  GoogleAnalytics.set({ page });
  GoogleAnalytics.pageview(page);
  Analytika.setSessionAttr({ page });
};

const styles = (theme) => ({
  container: {
    padding: "2em 3em",
    background: "#ffffff",
    borderRadius: "8px",
    boxShadow: "none",
    [theme.breakpoints.up("md")]: {
      boxShadow: "0px 1px 10px rgba(96, 108, 116, 0.1)",
    },
  },
});

class Container extends React.Component {
  componentDidMount() {
    // eslint-disable-next-line
    const page = this.props.location.pathname;
    trackPage(page);
  }

  componentDidUpdate(prevProps) {
    const currentPage = prevProps.location.pathname;
    const nextPage = this.props.location.pathname;

    if (currentPage !== nextPage) {
      trackPage(nextPage);
    }
  }

  render() {
    const { children, classes } = this.props;

    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item lg={6} md={8} sm={10} xs={12}>
            <Paper className={classes.container}>{children}</Paper>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

Container.propTypes = {
  location: Types.object.isRequired,
  classes: Types.object.isRequired,
  children: Types.node.isRequired,
};

export default withStyles(styles)(Container);
